import { render } from "./education-form.vue?vue&type=template&id=0b814b73&lang=true"
import script from "./education-form.vue?vue&type=script&lang=js"
export * from "./education-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__